import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';
import { PushNotificationAction } from '../API';

const client = generateClient();

export const sendNotificationToAllDevicesOperation = async (
  notificationTitle,
  notificationText,
) => {
  const response = await client.graphql({
    query: mutations.sendNotificationToAllDevices,
    variables: {
      notificationTitle,
      notificationText,
      action: PushNotificationAction.OPEN_APP,
    },
  });
  return response.data.sendNotificationToAllDevices;
};
